import React from 'react'

// Intro: Behaves like a Pulloutbox with big text inside it
const Intro = props => <div className="intro">{props.children}</div>

export default Intro
